<template>
  <header>
    <div class="header-wrapper">
      <div class="header-content">
        <!-- Logo Section -->
        <div class="logo-section">
          <div class="logo-icon-box">
            <svg class="logo-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path>
            </svg>
          </div>
          <div class="logo-text">
            <router-link to="/"> <h1 class="logo-title">Store Thanh Danh</h1></router-link>
            <p class="logo-subtitle">Mua sắm tiện lợi</p>
          </div>
        </div>

        <!-- Search Bar -->
        <div class="search-wrapper">
          <div class="search-input-container">
            <input
              type="text"
              placeholder="Bạn tìm gì..."
              class="search-input"
            />
            <svg class="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
        </div>

        <!-- Header Menu -->
        <div class="header-menu">
          <button class="location-btn">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
            <span class="location-text">Xem giá tại</span>
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          <button class="cart-btn">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path>
            </svg>
            <span class="cart-badge">0</span>
          </button>
        </div>
      </div>
    </div>
  </header>

  <!-- Navigation -->
  <nav>
    <div class="nav-wrapper">
      <ul class="nav-menu">
        <li>
          <a href="#" class="nav-link">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
            </svg>
            <span>Điện thoại</span>
          </a>
        </li>
        <li><a href="#" class="nav-link">Laptop</a></li>
        <li><a href="#" class="nav-link">Phụ kiện</a></li>
        <li><a href="#" class="nav-link">Smartwatch</a></li>
        <li><a href="#" class="nav-link">Tablet</a></li>
        <li><a href="#" class="nav-link">Máy cũ</a></li>
        <li><a href="#" class="nav-link">Khuyến mãi</a></li>
        <li><router-link to="/login-customer.html" class="nav-link">Lịch sử mua hàng</router-link></li>

      </ul>
    </div>
  </nav>

  <main>
    <router-view></router-view>
  </main>

  <!-- Footer -->
  <footer>
    <div class="footer-wrapper">
      <div class="footer-grid">
        <!-- Về công ty -->
        <div class="footer-section">
          <h3>Về công ty</h3>
          <ul class="footer-list">
            <li><a href="#" class="footer-link">Giới thiệu công ty</a></li>
            <li><a href="#" class="footer-link">Tuyển dụng</a></li>
            <li><a href="#" class="footer-link">Liên hệ</a></li>
          </ul>
        </div>

        <!-- Chính sách -->
        <div class="footer-section">
          <h3>Chính sách</h3>
          <ul class="footer-list">
            <li><a href="#" class="footer-link">Chính sách bảo hành</a></li>
            <li><a href="#" class="footer-link">Chính sách đổi trả</a></li>
            <li><a href="#" class="footer-link">Chính sách vận chuyển</a></li>
          </ul>
        </div>

        <!-- Hỗ trợ khách hàng -->
        <div class="footer-section">
          <h3>Hỗ trợ khách hàng</h3>
          <ul class="footer-list">
            <li><a href="#" class="footer-link">Hướng dẫn mua hàng</a></li>
            <li><a href="#" class="footer-link">Phương thức thanh toán</a></li>
            <li><a href="#" class="footer-link">Câu hỏi thường gặp</a></li>
          </ul>
        </div>

        <!-- Liên hệ -->
        <div class="footer-section">
          <h3>Liên hệ</h3>
          <ul class="footer-list">
            <li class="footer-info">📞 Hotline: 0935 999 975</li>
            <li class="footer-info">📧 Email: contactstd@gmail.com</li>
            <li class="footer-info">📍 36 Nguyễn Trãi - TP Huế, Việt Nam</li>
          </ul>
        </div>
      </div>

      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <p class="footer-copyright">© 2026 Store Thanh Danh. Mua sắm tiện lợi - Giá tốt mỗi ngày.</p>
      </div>
    </div>
  </footer>


</template>
<!-- <script>
export default {
  methods:{
    switchLoginMethod(method){
      const passwordField = document.getElementById('passwordField');
      const otpField = document.getElementById('otpField');
      const rememberSection = document.getElementById('rememberSection');
      const passwordBtn = document.getElementById('passwordBtn');
      const otpBtn = document.getElementById('otpBtn');

      if(method === 'password'){
        passwordField.classList.remove('hidden');
        otpField.classList.add('hidden');
        rememberSection.classList.remove('hidden');
        passwordBtn.classList.add('active');
        otpBtn.classList.remove('active');
      } else {
        passwordField.classList.add('hidden');
        otpField.classList.remove('hidden');
        rememberSection.classList.add('hidden');
        passwordBtn.classList.remove('active');
        otpBtn.classList.add('active');
      }
    },
  }
};
</script> -->
<style>
 @import '@/assets/css/home.css';
</style>
